export const refUuid = process.env.REACT_APP_REF_UUID;
export const dateLimit = new Date(process.env.REACT_APP_DATELIMIT ?? '2018-01-01');
